import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import NProgress from 'nprogress'

Vue.use(Router)

const router = new Router({
	mode: 'history',
	base: '/',
	routes: [
		{
			path: '/',
			name: 'Home',
			component: () => import('@/views/Home.vue'),
		},
		{
			path: '/projects',
			name: 'Projects',
			component: () => import('@/views/Projects.vue'),
		},
		{
			path: '/projects/:slug',
			name: 'Project',
			component: () => import('@/views/Project.vue'),
			props: true,
		},
		{
			path: '/reviews',
			name: 'Reviews',
			component: () => import('@/views/Reviews.vue'),
		},
		{
			path: '/privacy',
			name: 'Privacy',
			component: () => import('@/views/Privacy.vue'),
		},
	],
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) return savedPosition
		else if (to.hash) return { selector: to.hash }
		else return { x: 0, y: 0 }
	},
})

// Конфигурируем полосу загрузки
NProgress.configure({
	showSpinner: false,
	trickleSpeed: 200,
})

router.beforeEach((to, from, next) => {
	if (to.name) NProgress.start()
	next()
})

router.afterEach((to, from) => {
	store.state.general.theme = to.meta.theme || 'dark'
	NProgress.done()
})

export default router
